"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "createOpenItems", {
    enumerable: true,
    get: function() {
        return createOpenItems;
    }
});
const _ImmutableSet = require("./ImmutableSet");
function createOpenItems(iterable) {
    if (iterable === undefined) {
        return _ImmutableSet.ImmutableSet.empty;
    }
    if (_ImmutableSet.ImmutableSet.isImmutableSet(iterable)) {
        return iterable;
    }
    return _ImmutableSet.ImmutableSet.create(iterable);
}
